import { Children, cloneElement, useEffect, useState } from "react";
export function patch(children, newProps) {
    function getPatchFn(p) {
        return (typeof p === "function" ? p : (oldProps) => (Object.assign(Object.assign({}, oldProps), p)));
    }
    return Children.map(children, (child, index) => {
        const { props } = child;
        const patchFn = getPatchFn(newProps);
        return cloneElement(child, patchFn(props, index));
    });
}
export const useScrollInto = (ref) => useEffect(() => {
    if (ref && ref.current) {
        ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
}, [ref]);
export const useKeyboardListener = (handler) => useEffect(() => {
    document.addEventListener("keydown", handler);
    return () => {
        document.removeEventListener("keydown", handler);
    };
}, [handler]);
export const countSelectable = (children) => {
    const converted = Children.map(children, (child) => {
        const { props } = child;
        return "index" in props;
    });
    if (converted) {
        return converted.filter((x) => x === true).length;
    }
    return 0;
};
export const useKeyboardNavigation = (defaultCurrent, children, onSelect) => {
    const total = countSelectable(children) - 1;
    const [current, setCurrent] = useState(defaultCurrent);
    const [idle, setIdle] = useState(false);
    const next = () => setCurrent(current < total ? current + 1 : 0);
    const prev = () => setCurrent(current > 0 ? current - 1 : total);
    const routing = {
        ArrowDown: (evt) => {
            evt.preventDefault();
            next();
        },
        ArrowUp: (evt) => {
            evt.preventDefault();
            prev();
        },
        Enter: (evt) => {
            evt.preventDefault();
            if (onSelect)
                onSelect(current);
        },
        Tab: (evt) => {
            evt.preventDefault();
            if (onSelect)
                onSelect(current);
        },
    };
    const idleHandler = () => setIdle(false);
    const keydownHandler = (evt) => {
        const { key } = evt;
        setCurrent(defaultCurrent);
        setIdle(true);
        if (key in routing) {
            routing[key](evt);
        }
    };
    useEffect(() => {
        document.addEventListener("mousemove", idleHandler);
        return () => document.removeEventListener("mousemove", idleHandler);
    });
    useKeyboardListener(keydownHandler);
    return {
        current,
        idle,
    };
};
